<template>
  <div class="row modal-section" id="localizations">
    <div class="col-12">
      <div class="header">
        <h2 class="d-inline">Localization</h2>
        <button class="btn btn-success btn-sm float-right mr-0" @click="modelImport" :disabled="$store.state.currentTemplateName === 'global'">Import From Model</button>
        <button v-if="Object.keys(this.localizations).length !== 0" class="btn btn-success btn-sm float-right" @click="addRecord" :disabled="$store.state.currentTemplateName === 'global'">Add</button>
      </div>
      <table class="table table-sm table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Language</th>
            <th>Label</th>
            <th>Help Text</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, language) in localizations" :key="language" style="font-size: 14px;">
            <template v-if="editIndex !== language">
              <td class="verticalMiddle">{{ language }}</td>
              <td class="verticalMiddle"><button v-if="data.label !== undefined && data.label !== ''" @click="labelToTextStatic(data)" class="btn btn-sm btn-primary btnTableLocalization"><i class="fas fa-angle-double-right"/></button>{{ data.label }}</td>
              <td class="verticalMiddle"><button v-if="data.text !== undefined && data.text !== ''" @click="textToLabelStatic(data)" class="btn btn-sm btn-primary btnTableLocalization"><i class="fas fa-angle-double-left"/></button>{{ data.text }}</td>
              <td>
                <button class="btn btn-sm btn-secondary" @click="setEditIndex(language)">Edit</button>
                <button class="btn btn-sm btn-danger" @click="deleteIndex(language)">Delete</button>
                <button class="btn btn-sm btn-success" @click="restoreIndexStatic(data)">Restore</button>
              </td>
            </template>

            <template v-else>
              <td>
                <select class="form-control form-control-sm" v-model="editLanguage">
                  <option v-for="(language, index) in languages" :key="index" :value="language.code" :name="language.code">
                    {{ language.code }} - {{ language.name }}
                  </option>
                </select>
              </td>
              <td>
                <button v-if="editLabel !== undefined && editLabel !== '' && editLanguage !== 'new'" @click="labelToTextEdit()" class="btn btn-sm btn-primary"><i class="fas fa-angle-double-right"/></button><input type="text" class="form-control form-control-sm" v-model="editLabel">
              </td>
              <td>
                <button v-if="editText !== undefined && editText !== '' && editLanguage !== 'new'" @click="textToLabelEdit()" class="btn btn-sm btn-primary"><i class="fas fa-angle-double-left"/></button><input type="text" class="form-control form-control-sm" v-model="editText">
              </td>
              <td>
                <button v-if="editLanguage !== 'new' && editLabel !== undefined && editText !== undefined" class="btn btn-sm btn-success" @click="saveEdit">Save</button>
                <button class="btn btn-sm btn-secondary" @click="cancelEdit">Cancel</button>
                <button class="btn btn-sm btn-success" @click="restoreIndexEdit">Restore</button>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'localizations',

  props: {
    translations: {
      type: Object,
      default: {}
    },

    fieldId: {
      type: String,
      required: true
    },

    currentModel: {
      type: String,
      required: true
    }
  },

  mounted () {
    this.localizations = JSON.parse(JSON.stringify(this.translations))
    let that = this
    this.$on('updateLocalizations', function (localizationData) {
      that.localizations = JSON.parse(JSON.stringify(localizationData))
    })

    this.$bus.on('setFieldId', this.restoreInlineHelp)
  },

  data () {
    return {
      localizations: {},
      editIndex: -1,
      editLanguage: '',
      editLabel: '',
      editText: '',
      data: '',
      fieldData: {},

      // https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
      languages: [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Spanish' },
        { code: 'zh', name: 'Chinese' },
        { code: 'cs', name: 'Czech' },
        { code: 'da', name: 'Danish' },
        { code: 'nl', name: 'Dutch' },
        { code: 'eo', name: 'Esperanto' },
        { code: 'fi', name: 'Finnish' },
        { code: 'fr', name: 'French' },
        { code: 'ka', name: 'Georgian' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'ko', name: 'Korean' },
        { code: 'ku', name: 'Kurdish' },
        { code: 'fa', name: 'Perisian' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portugese' },
        { code: 'ro', name: 'Romanian' },
        { code: 'ru', name: 'Russian' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ur', name: 'Urdu' }
      ]
    }
  },

  methods: {
    restoreInlineHelp (fieldData) {
      this.fieldData = fieldData
    },

    changeInlineHelp (inlineHelp) {
      let that = this
      this.$store.commit('changeInlineHelp', {
        name: that.fieldData.name,
        label: inlineHelp.label,
        inlineHelp: inlineHelp.text
      })
    },

    restoreIndexEdit () {
      let that = this
      this.$bus.emit('getFieldId')
      let inlineHelp = this.$store.getters.getInlineHelpFromTemplate(this.fieldData.name)
      if (inlineHelp !== null) {
        this.editLabel = inlineHelp.label
        this.editText = inlineHelp.text
        this.changeInlineHelp({
          label: that.editLabel,
          text: that.editText
        })
      }
      this.saveInlineHelp()
    },

    restoreIndexStatic (data) {
      let that = this
      this.data = data
      this.$bus.emit('getFieldId')
      let inlineHelp = this.$store.getters.getInlineHelpFromTemplate(this.fieldData.name)
      if (inlineHelp !== null) {
        this.data.label = inlineHelp.label
        this.data.text = inlineHelp.text
        this.changeInlineHelp({
          label: that.data.label,
          text: that.data.text
        })
      }
      this.saveInlineHelp()
    },

    labelToTextStatic (data) {
      let that = this
      this.data = data
      this.$bus.emit('getFieldId')
      this.data.text = data.label
      this.changeInlineHelp({
        label: that.data.label,
        text: that.data.text
      })
      this.saveInlineHelp()
    },

    textToLabelStatic (data) {
      let that = this
      this.data = data
      this.$bus.emit('getFieldId')
      this.data.label = data.text
      this.changeInlineHelp({
        label: that.data.label,
        text: that.data.text
      })
      this.saveInlineHelp()
    },

    labelToTextEdit () {
      let that = this
      this.$bus.emit('getFieldId')
      this.editText = this.editLabel
      this.changeInlineHelp({
        label: that.editLabel,
        text: that.editText
      })
      this.saveInlineHelp()
    },

    textToLabelEdit () {
      let that = this
      this.$bus.emit('getFieldId')
      this.editLabel = this.editText
      this.changeInlineHelp({
        label: that.editLabel,
        text: that.editText
      })
      this.saveInlineHelp()
    },

    saveInlineHelp () {
      this.saveEdit()
    },

    addRecord () {
      this.editLanguage = ''
      this.editLabel = ''
      this.editText = ''
      this.localizations.new = {}
      this.setEditIndex('new')
    },

    setEditIndex (language) {
      this.editIndex = language
      this.editLanguage = language
      this.editLabel = this.localizations[language]['label']
      this.editText = this.localizations[language]['text']
    },

    saveEdit () {
      if (this.editLanguage !== 'new' && this.editLabel.length) {
        this.localizations[this.editLanguage] = {
          label: this.editLabel,
          text: this.editText
        }

        if (this.editLanguage !== this.editIndex) {
          delete this.localizations[this.editIndex]
        }
        this.localizations[this.editLanguage] = {
          label: this.editLabel,
          text: this.editText
        }
      }
      delete this.localizations.new
      this.editIndex = ''
      this.editLanguage = ''
      this.editLabel = ''
      this.editText = ''
      this.$parent.$emit('updateTranslations', this.localizations)
    },

    modelImport () {
      let newLabel = ''
      let newText = ''

      const apiUrl = this.$store.state.apiUrl
      this.axios.get(apiUrl + 'model/list').then(response => {
        this.$store.commit('setModels', response.data)
      })

      const foundModel = JSON.parse(JSON.stringify(this.$store.getters.searchModels(this.currentModel)))
      if (typeof foundModel._id === 'undefined') return
      if (typeof foundModel.label === 'undefined' || !foundModel.label.length) newLabel = this.fieldId
      else newLabel = foundModel.label

      const templateField = JSON.parse(JSON.stringify(this.$store.getters.currentTemplateField(this.fieldId)))
      newText = templateField.questionHelp

      this.localizations['en'] = {
        label: this.editLabel,
        text: this.editText
      }
      if (this.editIndex !== 'en') delete this.localizations['en']
      this.localizations['en'] = {
        label: newLabel,
        text: newText
      }
      this.$parent.$emit('updateTranslations', this.localizations)
    },

    cancelEdit () {
      this.editIndex = ''
      this.editLanguage = ''
      this.editLabel = ''
      this.editText = ''
    },

    deleteIndex (language) {
      delete this.localizations[language]
      this.$parent.$emit('updateTranslations', this.localizations)
    }
  },

  beforeDestroy () {
    this.$off('updateLocalizations')
    this.$bus.$off('setFieldId')
  }
}
</script>

<style lang="scss" scoped>
  #localizations {
    h1 {
      display: inline;
    }

    .header button {
      margin-right: 10px;
    }

    .btn {
      // margin: 5px;
    }
  }
  .verticalMiddle{
    vertical-align: middle !important;
  }

  .btnTableLocalization{
    margin-right: 5px !important;
    margin-top: 0px !important;
    margin-left: 0px !important;
    margin-bottom: 0px !important;
    padding: 0.05rem 0.4rem !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/modal-edit/Localizations.vue